import React from 'react';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from '../DashboardOverviewNew.module.scss';
import { HEATMAP_TIME_LABELS } from '../data/dashboardOverviewNew.data';

const ACTIVITY_HEATMAP_TOOLTIP = {
  description:
    'Shows when activity happens across the day and week — darker cells mean more tracked activity in that hour, relative to the busiest hour in the last 7 days.',
};

const LEGEND_STEPS = [
  0.05, 0.15, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 0.87, 1.0,
];
const LOW = [219, 234, 254]; // #dbeafe  blue-100
const HIGH = [26, 112, 228]; // #1a70e4  bright blue

function lerp(a, b, t) {
  return Math.round(a + (b - a) * t);
}

const cellStyle = (intensity) =>
  intensity < 0.05
    ? { backgroundColor: '#f2f4f7' }
    : {
        backgroundColor: `rgb(${lerp(LOW[0], HIGH[0], intensity)}, ${lerp(LOW[1], HIGH[1], intensity)}, ${lerp(LOW[2], HIGH[2], intensity)})`,
      };

export const ActivityHeatmap = ({ data, isLoading = false }) => {
  const rows = data || [];
  return (
    <div
      className={styles.chartCardMedium}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <div className={styles.cardTitleGroup}>
          <span className={styles.cardTitle}>Activity Heatmap</span>
          <InfoTooltip title="Activity Heatmap" {...ACTIVITY_HEATMAP_TOOLTIP} />
        </div>
      </div>

      <div className={styles.heatmapWrapper}>
        {!rows.length && (
          <div
            style={{
              padding: '32px 0',
              textAlign: 'center',
              color: 'var(--gray-400)',
              fontSize: 13,
            }}
          >
            No activity data
          </div>
        )}
        {rows.map((row) => (
          <div key={row.day} className={styles.heatmapRow}>
            <span className={styles.heatmapDayLabel}>{row.day}</span>
            {row.slots.map((intensity, idx) => (
              <div
                key={idx}
                className={styles.heatmapCell}
                style={cellStyle(intensity)}
                title={`${row.day} ${HEATMAP_TIME_LABELS[idx]}: ${Math.round(intensity * 100)}%`}
              />
            ))}
          </div>
        ))}

        <div className={styles.heatmapTimeRow}>
          {HEATMAP_TIME_LABELS.filter((_, i) => i % 4 === 0).map((t) => (
            <span key={t} className={styles.heatmapTimeLabel}>
              {t}
            </span>
          ))}
        </div>

        <div className={styles.heatmapLegend}>
          <span>Low activity</span>
          <div className={styles.heatmapLegendBar}>
            {LEGEND_STEPS.map((step) => (
              <div
                key={step}
                className={styles.heatmapLegendCell}
                style={cellStyle(step)}
              />
            ))}
          </div>
          <span>High activity</span>
        </div>
      </div>
    </div>
  );
};
